export const smartDocStaticParamType_Tag = 'tag';
//# sourceMappingURL=types.js.map